import { useCallback, useEffect, useState } from 'react';
import { orders } from 'services';
import { skeletonFactory, useHandleRequest, ORDER_STATUSES } from 'shared';
import { v4 as uuidv4 } from 'uuid';

const orderDummy = skeletonFactory.order();
const orderEmpty = {};

export function useOrder(id) {
  const [orderData, setOrderData] = useState(id ? orderDummy : { ...orderEmpty, id: uuidv4() });
  const { request, errorInfo, setErrorInfo } = useHandleRequest();

  const getData = useCallback(async () => {
    await request(async () => {
      const response = await orders.getById(id);
      if (response) {
        setOrderData(response.data || {});
      }
    }, false);
  }, [id, request]);

  useEffect(() => {
    id && getData();
  }, [id, getData]);

  const editOrderStatus = useCallback(
    async newStatus => {
      return await request(async () => {
        let response;
        switch (newStatus) {
          case ORDER_STATUSES.created:
            response = await orders.updateStatusCreated(id);
            break;

          default:
            break;
        }

        if (response) {
          await getData();
          return id;
        }
      }, false);
    },
    [id, getData, request]
  );

  return {
    order: orderData,
    errorInfo,
    setErrorInfo,
    editOrderStatus
  };
}
